import React,{Component} from 'react';
import {connect} from "react-redux";

import './favoritesPopup.scss';

import {getFavoriets} from "../../../../redux/actions";
import {getFullMediaUrl, getLocalStorageItem} from "../../../../app/static_func";
import * as keys from '../../../../constants/storage-keys';

//components import
import VehicleCard from 'components/forms/vehicle_card/vehicleCard.js';

import closeIcon from 'assets/icons/close_icon.svg';
import favoritesCounter from 'assets/icons/favorites_counter.svg';
import noFav from 'assets/mock/no-fav.png';
import talkToUs from 'assets/icons/talk_to_us.svg';

class FavoritesPopup extends Component{
    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,
            cardsToShow:4
        };
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
        this.handleLoadClick = this.handleLoadClick.bind(this);
        this.getFavorites = this.getFavorites.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    componentDidUpdate(prevProps){

    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
        if (JSON.parse(getLocalStorageItem(keys.FAVORITES)) === null){
            this.props.getCar({licenseNumbers: 0})
        }
        else
            this.props.getCar({licenseNumbers: JSON.parse(getLocalStorageItem(keys.FAVORITES))});
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }


    handleLoadClick(){
        const cardsToShow = this.state.cardsToShow;
        this.setState({cardsToShow:(cardsToShow + 4)});
    }

    getFavorites(){
        const data = this.props.carDetails;


        let i = this.state.cardsToShow;

        let length = Object.keys(data).length;

        if(i > length)
            i = length;

        let items = [];

        let j = 0;
        for(let key in data){
            if (j === i)
                break;

            let mainPhoto = null;

            if (data[key] !== null) {
                mainPhoto = data[key].images.filter(item => {
                    return item['is-main-image'];
                });
            }


            if (data[key] !== null) {
                items.push(
                    <div className='oneCard' key={data[key].id}>
                        <VehicleCard id={data[key]['license-number']}
                                     model={data[key].year + ' ' + data[key].manufacturer + ' ' + data[key].model}
                                     subModel={data[key].submodel}
                                     km={data[key]['important-info'].km.value}
                                     price={data[key].price}
                                     grade={parseFloat(data[key]['important-info']['peeps-scroe'].value !== null ? data[key]['important-info']['peeps-scroe'].value : '8.2') * 10}
                                     displayPhoto={getFullMediaUrl(mainPhoto[0].image.path)}
                                     licenseNum={data[key]['license-number']}
                                     history={this.props.history}
                                     onLoveClicked={() => {
                                         this.setState()
                                     }}
                        />
                    </div>
                );
                j++;
            }
        }
        return items;
    }

    render() {

        const isMobileOrTablet = this.props.deviceState === 'mobile' || this.props.deviceState === 'tablet';

        const hasFavorites = this.getFavorites().length > 0;

        const isMore = Object.keys(this.props.carDetails).length > this.getFavorites().length;

        return (
            <div className = { "backdrop favoritesWrapper " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper " + this.state.animation_class} onClick = { (e) => e.stopPropagation()}>
                    <div className='favorites'>
                        <div className='header'>
                            <div className='counter-title'>
                                <h3 className='title'>רכבים שאהבת</h3>
                                <div className='counter'>
                                    <img src={favoritesCounter} alt='\' className='counterIcon'/>
                                    <span className='count'>{Object.keys(this.props.carDetails).length}</span>
                                </div>
                            </div>
                            <img src={closeIcon} alt='/' className='close_icon' onClick={()=> this.props.backdropClick()}/>
                        </div>
                        <div className='divider'/>
                        {hasFavorites &&
                        <div className='vehicleList'>
                            {this.getFavorites()}
                        </div>
                        }
                        {!hasFavorites &&
                            <div className='no-results'>
                                <h3> רשימת הרכבים שלך ריקה כרגע, אפשר להוסיף רכבים לרשימה בלחיצה על הסימון "לב" בפינה השמאלית של כל רכב</h3>
                                <img src={noFav} alt='/'/>
                            </div>
                        }
                        <div className='more'>
                            {isMore && <span className='link' onClick={()=>this.handleLoadClick()}>טען עוד </span>}
                            {isMobileOrTablet &&
                            <img src={talkToUs} alt='\' className='moreIcon'/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        carDetails: store.data.Favorites,
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        getCar:(payload) => dispatch(getFavoriets(payload)),
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(FavoritesPopup);